'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Fees;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Fees(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-fees ' + className,
      width: width, height: height,
      viewBox: '0 0 48 48' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { fill: color, d: 'M46,2 L2,2 C0.897,2 0,2.897 0,4 L0,37 C0,38.103 0.897,39 2,39 L9.814,39 C9.644,38.19 9.555,37.353 9.525,36.5 L2.5,36.5 L2.5,4.5 L45.5,4.5 L45.5,36.5 L38.475,36.5 C38.445,37.353 38.356,38.19 38.186,39 L46,39 C47.103,39 48,38.103 48,37 L48,4 C48,2.897 47.103,2 46,2' }),
      _react2.default.createElement('polygon', { fill: color, points: '0 18 48 18 48 10 0 10' }),
      _react2.default.createElement('path', { fill: color, d: 'M24,24 C17.373,24 12,29.373 12,36 C12,42.627 17.373,48 24,48 C30.627,48 36,42.627 36,36 C36,29.373 30.627,24 24,24 M24,26.5 C29.238,26.5 33.5,30.762 33.5,36 C33.5,41.238 29.238,45.5 24,45.5 C18.762,45.5 14.5,41.238 14.5,36 C14.5,30.762 18.762,26.5 24,26.5' }),
      _react2.default.createElement('path', { fill: color, d: 'M23.74487 43.0009065C21.34487 43.0009065 19.12787 41.5989065 18.09687 39.4299065 17.85987 38.9309065 18.07287 38.3349065 18.57087 38.0979065 19.06987 37.8599065 19.66587 38.0729065 19.90387 38.5719065 20.60487 40.0469065 22.11287 41.0009065 23.74487 41.0009065 25.37687 41.0009065 26.88487 40.0469065 27.58587 38.5719065 27.82387 38.0729065 28.41887 37.8589065 28.91887 38.0979065 29.41687 38.3349065 29.62987 38.9309065 29.39287 39.4299065 28.36187 41.5989065 26.14487 43.0009065 23.74487 43.0009065M22 33.5C22 34.329 21.329 35 20.5 35 19.671 35 19 34.329 19 33.5 19 32.671 19.671 32 20.5 32 21.329 32 22 32.671 22 33.5M29 33.5C29 34.329 28.329 35 27.5 35 26.671 35 26 34.329 26 33.5 26 32.671 26.671 32 27.5 32 28.329 32 29 32.671 29 33.5' }),
      _react2.default.createElement('path', { fill: color, d: 'M46,2 L2,2 C0.897,2 0,2.897 0,4 L0,37 C0,38.103 0.897,39 2,39 L9.814,39 C9.644,38.19 9.555,37.353 9.525,36.5 L2.5,36.5 L2.5,4.5 L45.5,4.5 L45.5,36.5 L38.475,36.5 C38.445,37.353 38.356,38.19 38.186,39 L46,39 C47.103,39 48,38.103 48,37 L48,4 C48,2.897 47.103,2 46,2' }),
      _react2.default.createElement('polygon', { fill: color, points: '0 18 48 18 48 10 0 10' })
    )
  );
}

Fees.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Fees/Fees.js
// module id = 1183
// module chunks = 1